/**
 * Detects low-end desktop devices that should skip expensive effects like backdrop-blur.
 * Returns true for low-end PCs, false for capable devices.
 */
export function isLowEndPC() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;

  // Skip check on mobile - mobile handling is already optimized
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.innerWidth < 1024;
  if (isMobile) return false;

  // < 8 GB RAM - typical for low-end laptops with integrated graphics
  if (navigator.deviceMemory !== undefined && navigator.deviceMemory < 8) {
    return true;
  }

  // < 8 logical cores - correlates with weaker CPUs and usually integrated GPUs
  if (navigator.hardwareConcurrency !== undefined && navigator.hardwareConcurrency < 8) {
    return true;
  }

  // If we can't detect hardware (Firefox/Safari), assume low-end to be safe
  if (navigator.deviceMemory === undefined) {
    return true;
  }

  return false;
}
